import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { SessionService } from 'src/app/shared/_service/session.service';

@Component({
	selector: 'app-accessori',
	templateUrl: './accessori.component.html',
})
export class AccessoriComponent implements OnInit {
	constructor(
		private session: SessionService,
		private router: Router,
		private route: ActivatedRoute,
	) {}

	accessories = [];
	accessories_ = [];

	accessoriVisualizzati = [];
	colori = [];
	famiglie = [];
	accessori = 'Accessories';
	showColors = false;
	tipologiaSelezionata = false;

	ngOnInit() {
		this.accessoriVisualizzati = [];
		this.colori = [];
		this.famiglie = [];

		this.session.getAccessori().subscribe((accessori) => {
			this.accessories = accessori;
			this.accessories_ = accessori;

			if (this.accessories_) {
				this.accessories_.forEach((p) => {
					p.prodottiCommerciali.forEach((pc) => (pc.quantita = 1));
				});
				console.log('Accessories after filter by this user >>> ', this.accessories_);
			}
			this.filtra();
		});
	}
	getDescrizione(accessories) {
		return (
			accessories.prodottiCommerciali[0].descrizioni.find((d) => d.lingua.codice === 'US') ||
			accessories.descrizioni.find((d) => d.lingua.codice === 'US')
		);
	}

	stepQuantita(mode, prodottoCommerciale) {
		if (prodottoCommerciale) {
			if (prodottoCommerciale.quantita > 0 && mode === '-') {
				prodottoCommerciale.quantita--;
			}
			if (
				prodottoCommerciale.quantita < 100 &&
				mode === '+' &&
				!(prodottoCommerciale.statoGiacenza === 'IN_STOCK' && prodottoCommerciale.giacenza <= prodottoCommerciale.quantita)
			) {
				prodottoCommerciale.quantita++;
			}
		}
	}

	buy({ codiceTecnico, quantita }) {
		this.session.setCarrello(codiceTecnico, quantita, true).subscribe(() => this.router.navigate(['/cart']));
	}

	reset() {
		this.famiglie = [];
		this.colori = [];
		this.showColors = false;
		this.tipologiaSelezionata = false;

		this.accessoriVisualizzati = this.accessories_;

		this.accessoriVisualizzati.forEach((p) => {
			//Inserisce tutte le famiglie presenti negli accessori[];
			if (!this.famiglie.find((f) => f.value_ === p.famiglia)) {
				this.famiglie.push({ valore: p.famiglia, value_: p.famiglia, selected: false });
			}
		});

		this.accessoriVisualizzati.forEach((p) =>
			p.prodottiCommerciali.forEach((pc) => {
				//Inserisce tutti i colori presenti negli accessori[];
				if (!this.colori.find((c) => c.valore === pc.colore.idBertazzoni)) {
					this.colori.push({
						typeColor: true,
						value_: pc.colore.value_,
						valore: pc.colore.idBertazzoni,
						codiceHtml: pc.colore.codiceHtml,
						ordine: pc.colore.ordine,
						disabled: true,
					});
				}

				//CASE ARRAY OF COLORS
				/** 
            pc.colore.forEach(colore => {
             if (!this.colori.find(c => c.valore === pc.colore.idBertazzoni)) {
                 this.colori.push({ typeColor: true, value_: pc.colore.value_, valore: pc.colore.idBertazzoni, codiceHtml: pc.colore.codiceHtml, ordine: pc.colore.ordine, disabled: true });
             } 
            });
            */
			}),
		);
		this.colori = this.colori.sort((c1, c2) => (c1.ordine || 0) - (c2.ordine || 0));
		this.accessories = this.accessoriVisualizzati;
	}

	/**
	 *  filtra()
	 *  Esegue i filtri in pagina e inserisce tutti i prodotti dividendoli per serie o categoria
	 *  @param filtro -> Il filtro: un oggetto di this.famiglie o this.linee o this.colori
	 *  @param valore -> Se il filtro é selezionato o meno. Boolean
	 */
	filtra(filtro?, value?) {
		//console.log("Filtro >>>>>> ", filtro);
		//console.log("Value >>>>>>> ", value);

		if (filtro) {
			//Viene eseguito quando al metodo filtra() vengono passati i parametri (chiamata tranne html template);

			filtro.selected = value;

			if (!filtro.typeColor) {
				//Se non ho il campo typeColor allora è un filtro di tipo famiglie;
				if (filtro.selected) {
					//case true;
					this.famiglie.forEach((f) => {
						if (f.value_ !== filtro.value_) {
							f.disabled = true;
						} else f.disabled = false;
					});
					this.tipologiaSelezionata = true;
					//Filtro gli accessori per la famiglia selezionata;
					const famiglieDeselezionati = this.famiglie.filter((f) => !f.selected);
					if (famiglieDeselezionati.length < this.famiglie.length) {
						famiglieDeselezionati.forEach(
							({ value_ }) => (this.accessoriVisualizzati = this.accessoriVisualizzati.filter((p) => p.famiglia !== value_)),
						);
						this.accessories = this.accessoriVisualizzati;
					}
					//Aggiorno i colori per la mamiglia selezionata;
					this.colori = [];
					this.accessories.forEach((acc) => {
						if (!this.colori.find((c) => c.valore === acc.prodottiCommerciali[0].colore.idBertazzoni)) {
							this.colori.push({
								typeColor: true,
								value_: acc.prodottiCommerciali[0].colore.idBertazzoni,
								valore: acc.prodottiCommerciali[0].colore.idBertazzoni,
								codiceHtml: acc.prodottiCommerciali[0].colore.codiceHtml,
								ordine: acc.prodottiCommerciali[0].colore.ordine,
								disabled: false,
							});
						}

						//CASE ARRAY OF COLORS
						/**
                        acc.prodottiCommerciali[0].colore.forEach(colore => {
                            if (!this.colori.find(c => c.value_ === colore.idBertazzoni)) {
                                this.colori.push({ typeColor: true, value_: colore.idBertazzoni, valore: colore.idBertazzoni, codiceHtml: colore.codiceHtml, ordine: colore.ordine, disabled: false });
                            }   
                        });
                         */
						this.colori.forEach((f) => (f.disabled = false));
					});
				} else {
					//case false; >> La selezione della famiglia è univoca, pertanto basta fare un reset al deselezionare una di queste;
					this.reset();
				}
			} else {
				//Altrimenti è un filtro di tipo colori;
				const coloriSelezionati = this.colori.filter((c) => c.selected);
				if (coloriSelezionati.length > 0) {
					this.accessories = [];
					coloriSelezionati.forEach(({ value_ }) => {
						// Cerco i prodotti con quel colore
						const prodottiConColore = this.accessoriVisualizzati.filter((a) => a.prodottiCommerciali[0].colore.idBertazzoni === value_);

						//CASE ARRAY OF COLORS
						// const prodottiConColore = this.accessoriVisualizzati.filter(a => a.prodottiCommerciali[0].colore.find(colore=> colore.idBertazzoni === value_));

						prodottiConColore.forEach((pC) => {
							if (!this.accessories.find((a) => a.id === pC.id)) {
								this.accessories.push(pC);
							}
						});
					});
				} else {
					this.accessories = this.accessoriVisualizzati;
				}
				this.colori.filter((c) => c.value_ === filtro.value_);
			}
		} else {
			this.reset();
		}
	}

	isNew(accessorio) {
		const date = moment(accessorio.dataCreazione, 'dd/MM/yyyy');
		return moment().diff(date, 'months', true) < 3;
	}
}
